/**
 * Copyright (c) 2018-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
var EmptyArray = [];
export var EmptyCarbohydrates = {
  links: EmptyArray,
  terminalLinks: EmptyArray,
  elements: EmptyArray,
  partialElements: EmptyArray,
  getElementIndices: function () {
    return EmptyArray;
  },
  getLinkIndices: function () {
    return EmptyArray;
  },
  getTerminalLinkIndices: function () {
    return EmptyArray;
  }
};